var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      class: _setup.buttonVariantClass,
      attrs: { title: _setup.props.title, disabled: _setup.props.disabled },
      on: { click: _setup.clickHandler },
    },
    [
      _setup.props.prependIconSrc
        ? _c("img", {
            class: ["icon-img", _setup.iconSizeClass],
            style: _setup.iconStyle,
            attrs: { src: _setup.props.prependIconSrc, alt: "icon" },
          })
        : _setup.props.prependIcon
        ? _c("span", {
            class: [_setup.props.prependIcon, _setup.iconSizeClass],
          })
        : _vm._e(),
      _setup.getText && !_setup.props.mini
        ? _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_setup.getText))])
        : _vm._e(),
      _setup.props.appendIconSrc
        ? _c("img", {
            class: ["icon-img", _setup.iconSizeClass],
            style: _setup.iconStyle,
            attrs: { src: _setup.props.appendIconSrc, alt: "icon" },
          })
        : _setup.props.appendIcon
        ? _c("span", { class: [_setup.props.appendIcon, _setup.iconSizeClass] })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }